module.exports = __webpack_public_path__ + "static/img/iPhoneX_model.8fa6694c.png";